
















import { Component, Vue } from 'vue-property-decorator'
import TsTable from './TsTable.vue' // @ is an alias to /src

@Component({
  components: {
    TsTable
  }
})
export default class Home extends Vue {
  /**
   * todo 当前组件为测试 demo
   *  参数
   *    tableData 表格 map
   *      data 数组
   *      currentPage 当前页数
   *      pageSize    每页多少条
   *      total 数据总条数
   *    tableTitleObj 表格title信息
   *      title 表格标题
   *      options 标题右侧按钮选项
   *        dropdown 按钮状态是否为下拉
   *        type 类型 add  edit ...
   *        name  按钮文字
   *        btnType 按钮类型  wraning info ..
   *        arr  下拉组按钮选项 对象参数和 父级 options 一样，
   *              dropdown === false 时(即正常按钮排序)，参数传入 options.arr数组中就好了
   *
   *    tableHead 表头信息
   *      labelName 表头名称
   *      propName  column 的 prop
   *      type 表头类型 目前支持 radio（单选） select(全选、反选)、first(首行可点击)、 sort(排序)、 select（下拉搜索）、search(文字检索)、edit(编辑)
   *      详情信息见 tableHead 对象
   *
   *    tableSelectOpt 批量操作表格显示内容(勾选复选框、单选框后的状态更改)
   *
   *    TODO tips  tableHead 中的配置项(options) 和 tableTitleObj中的配置项类似
   *
   * 方法
   *
   */
  tableData: object = {
    data: [],
    currentPage: 1,
    pageSize: 10,
    total: 101
  };

  tableTitleObj = {
    title: '表格标题',
    options: {
      dropdown: true,
      type: 'add',
      name: '新增',
      arr: [
        {
          type: 'del',
          name: '删除'
        },
        {
          type: 'export',
          name: '导出'
        }
      ]
    }
  };

  tableHead = [
    {
      type: 'radio', // radio
      defaultValue: 1
    },
    // {
    //   type: 'select',
    // },
    {
      type: 'first',
      propName: 'date',
      labelName: '日期',
      options: {
        type: 'sort',
        optionArr: [
          {
            type: 'rise',
            name: '升序',
            icon: 'el-icon-top'
          },
          {
            type: 'decline',
            name: '降序',
            icon: 'el-icon-bottom'
          }
        ]
      }
    },
    {
       propName: 'filterPropName',
      labelName: '过滤表单元格',
      filterBody: [
        {
          type: 'Invest',
          name: '投资规划'
        }, {
          type: 'Family',
          name: '家庭基础保障'
        }, {
          type: 'Pension',
          name: '退休规划'
        }, {
          type: 'OthersInvest',
          name: '其他-投资相关'
        }, {
          type: 'OthersRisk',
          name: '其他-潜在风险相关'
        },
        {
          type: 'OthersAllocation',
          name: '其他-分配相关'
        }
      ]
    },
    {
      type: 'first',
      propName: 'date',
      labelName: '日期1',
      options: {
        type: 'sort',
        optionArr: [
          {
            type: 'rise',
            name: '升序',
            icon: 'el-icon-top'
          },
          {
            type: 'decline',
            name: '降序',
            icon: 'el-icon-bottom'
          }
        ]
      }
    },
    {
      propName: 'name',
      labelName: '姓名',
      options: {
        type: 'select',
        optionArr: [
          {
            label: '下拉选中1',
            id: '1'
          },
          {
            label: '下拉选中2',
            id: '2'
          },
          {
            label: '下拉选中3',
            id: '3'
          }
        ]
      }
    },
    {
      propName: 'address',
      labelName: '地址',
      options: {
        type: 'search'
      }
    },
    {
      type: 'edit',
      labelName: '编辑',
      propName: 'edit',
      options: {
        dropdown: false,
        type: 'add',
        name: '新增',
        btnType: 'warning',
        arr: [
          {
            type: 'del',
            name: '删除',
            btnType: 'warning'
          },
          {
            type: 'export',
            name: '导出'
          },
          {
            btnType: 'info',
            name: '导出1'
          }
        ]
      }
    }
  ];

  tableSelectOpt = [
    {
      type: 'error',
      name: '批量删除',
      icon: 'el-icon-delete',
      color: 'red'
    },
    {
      type: 'info',
      name: '信息',
      icon: 'el-icon-info',
      color: 'blue'
    }
  ];

  created () {
    setTimeout(() => {
      const _tableData: any[] = []
      for (let i = 0; i < 2; i++) {
        _tableData.push({
          id: i,
          filterPropName: 'Family',
          date: '2016-05-02',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄'
        })
      }
      (this.tableData as any).data = _tableData
    }, 2000)
  }

  /**
   *   点击下拉或者按钮按钮触发
   *    type 按钮类型
   *    tableItem 如果按钮存在表格中 tableItem就是当前项
   */
  handleTableBtn (type: string, tableItem: any) {
    console.log(
      '点击了表格title右侧下拉按钮，类型：',
      type,
      '按钮存在表格中显示',
      tableItem
    )
    this.$router.push('/manage/userManage')
  }

  // 点击表格第一列
  handleTableFirst (row: object, arr: object) {
    console.log(row, arr)
  }

  /**
   * handleSelectInfo 处理选中操作
   * selectArr 选中内容
   * item 点击当当前项
   * idx  item索引
   */
  handleSelectInfo (arr: any[], item: any, idx: number) {
    console.log('选中内容', arr, '选中信息当前项：', item, '当前索引:' + idx)
  }

  /**
   * handleFilter 过滤处理filter
   */
  handleFilter (tags: any) {
    console.log('过滤结果：', tags)
  }

  // 分页相关
  // 选择条数
  handleSizeChange (val: number) {
    (this.tableData as any).pageSize = val
  }

  // 当前第几页
  handleCurrentChange (val: number) {
    (this.tableData as any).currentPage = val
  }
}
